import routerOptions0 from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/router.options.ts";
import routerOptions1 from "/home/runner/work/ott-web-portal2/ott-web-portal2/node_modules/.pnpm/nuxt@3.8.2_embdxb6l2vaxuas5chfa5uzh34/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}